'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioGroupInput = function (_Component) {
  _inherits(RadioGroupInput, _Component);

  function RadioGroupInput(props) {
    _classCallCheck(this, RadioGroupInput);

    var _this = _possibleConstructorReturn(this, (RadioGroupInput.__proto__ || Object.getPrototypeOf(RadioGroupInput)).call(this, props));

    _this.state = { hasDeviated: false };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.renderOptions = _this.renderOptions.bind(_this);
    return _this;
  }

  _createClass(RadioGroupInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var recommendedValue = _ref.recommendedValue;
      var hasDeviated = this.state.hasDeviated;
      var _props = this.props,
          id = _props.id,
          onChange = _props.onChange,
          oldValue = _props.recommendedValue;

      // Use recommended while not deviated.

      if (!hasDeviated && recommendedValue && recommendedValue !== oldValue) {
        onChange(id, recommendedValue);
      }
    }
  }, {
    key: 'handleChange',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var value = _ref2.target.value;

        var _props2, id, onChange, onBlur;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, id = _props2.id, onChange = _props2.onChange, onBlur = _props2.onBlur;

                if (value !== this.props.value) {
                  this.setState({ hasDeviated: true });
                }

                _context.next = 4;
                return onChange(id, value);

              case 4:
                onBlur();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleChange(_x) {
        return _ref3.apply(this, arguments);
      }

      return handleChange;
    }()
  }, {
    key: 'renderOptions',
    value: function renderOptions() {
      var _this2 = this;

      var _props3 = this.props,
          id = _props3.id,
          value = _props3.value,
          options = _props3.options;


      return options.map(function (option) {
        return _react2.default.createElement(
          'div',
          { key: option.value, className: 'radio-input-item ' + option.value },
          _react2.default.createElement('input', {
            type: 'radio',
            id: id + '-' + option.value,
            name: id,
            value: option.value,
            checked: value === option.value,
            onChange: _this2.handleChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: id + '-' + option.value, className: 'radio-input-label ' },
            option.label
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var valid = this.props.valid;

      var validClass = valid ? '' : ' invalid';

      return _react2.default.createElement(
        'div',
        { className: 'radio-group-input' + validClass },
        this.renderOptions()
      );
    }
  }]);

  return RadioGroupInput;
}(_react.Component);

RadioGroupInput.defaultProps = {
  value: '',
  valid: true,
  options: [],
  recommendedValue: ''
};


RadioGroupInput.propTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  valid: _propTypes2.default.bool,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.func]).isRequired
  })),
  recommendedValue: _propTypes2.default.string
};

RadioGroupInput.displayName = 'RadioGroupInput';

exports.default = RadioGroupInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/elements/RadioGroupInput.js
// module id = 462
// module chunks = 0